import { Button, Modal, Stack } from "react-bootstrap";
import { StyledModalTitle } from "../../../@ui/StyledModalTitle";
import { useState } from "react";
import { useCurrencyContext } from "../../../context/Currency/CurrencyContext";
import { Typeahead } from "react-bootstrap-typeahead";
import { ErrorText } from "../../../@ui/ErrorText";
import useBasketService from "../../../hooks/useBasketService";
import { Basket } from "../../../types/Basket/Basket";
import { useBasketContext } from "../../../context/Basket/BasketContext";
import ThemedModal from "../../../@ui/Modal/ThemedModal";
import { Currency } from "../../../types/Currency/Currency";

export interface CurrencyModalProps {
  onHide: () => void;
  onSelect?: (currency: Currency) => void;
}

interface Option {
  label: string;
  value: string;
}

const CurrencyModal = ({ onHide, onSelect }: CurrencyModalProps) => {
  const { currencies, selectedCurrency } = useCurrencyContext();

  const [submit, setSubmit] = useState(false);

  const [selected, setSelected] = useState<Option[]>([
    {
      label: `(${selectedCurrency?.symbol}) ${selectedCurrency?.name}`,
      value: selectedCurrency?.code,
    },
  ] as Option[]);

  const [options] = useState<Option[]>(
    currencies?.map(
      (c) =>
        ({
          label: `(${c.code}) ${c.name} ${c.symbol}`,
          value: c.code,
        } as Option)
    ) ?? []
  );

  const onSubmit = () => {
    if (selected.length === 0) {
      setSubmit(true);
      return;
    }
    const currency = currencies?.find((c) => c.code === selected[0].value);
    if (currency) {
      onSelect && onSelect(currency);
    }
    onHide();
  };

  return (
    <ThemedModal centered show={true} onHide={onHide} backdrop="static">
      <Modal.Header className="bg-secondary text-white" closeButton>
        <StyledModalTitle>Change Currency</StyledModalTitle>
      </Modal.Header>
      <Modal.Body>
        {currencies && (
          <Stack>
            <Typeahead
              id="currency-typeahead"
              clearButton
              options={options}
              selected={selected}
              onInputChange={(input) => {
                if (!input) {
                  setSelected([]);
                }
              }}
              onChange={(selected) => setSelected(selected as Option[])}
            />
            {submit && selected.length === 0 && (
              <ErrorText className="text-danger">
                Please select a currency
              </ErrorText>
            )}
            <Button
              style={{ alignSelf: "flex-end" }}
              onClick={() => onSubmit()}
              className="w-25 mt-2"
            >
              Submit
            </Button>
          </Stack>
        )}
      </Modal.Body>
    </ThemedModal>
  );
};

export default CurrencyModal;
